import * as React from 'react';
import {connect} from 'react-redux';
import {Redirect} from 'react-router-dom';
import {loadLogout, LogoutState, IsAuthentificatedState, RequestApiResult} from 'loopback-react-request';
import { RouterState } from 'connected-react-router';

import './LogoutButton.scss';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './LogoutButton.messages';
import { clearQueryParams } from 'src/api';


export interface LogoutButtonProps {
  buttonMessage?: any;
  classStyle?: string;
  authenticator: IsAuthentificatedState;
  dispatch: any;
  location: RouterState['location'];
  logout: LogoutState;
}

export interface LogoutButtonState {
  fireRedirect: boolean;
}

export class LogoutButtonComponent extends React.Component<LogoutButtonProps, LogoutButtonState> {
  constructor(props: LogoutButtonProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {fireRedirect: false};
  }

  UNSAFE_componentWillReceiveProps(nextProps: LogoutButtonProps) {
    const {logout} = nextProps;
    this.setState({fireRedirect: logout.loaded && !logout.updating});
  }

  render() {
    const { fireRedirect } = this.state;
    const { from } = this.props.location.state || '/';
    let classStyle = this.props.buttonMessage !== undefined ? this.props.classStyle : 'logout-btn btn btn-secondary text-center';
    let buttonMessage = this.props.buttonMessage && typeof this.props.buttonMessage === typeof MESSAGES ? this.props.buttonMessage : MESSAGES.logoutButton;
    return (
      <a className={classStyle} href="/" onClick={this.handleClick}>
        <FormattedMessage {...buttonMessage} />
        {fireRedirect && (
          <Redirect to={from || '/'} />
        )}
      </a>
    );
  }
  
  private handleClick(event: React.SyntheticEvent<HTMLAnchorElement>) {
    event.preventDefault();
    this.props.dispatch(loadLogout(this.props.authenticator.accessToken));
    this.props.dispatch(clearQueryParams());
  }
}

interface StateProps {
  authenticator: IsAuthentificatedState;
  router: RouterState;
  logout: RequestApiResult<{}>;
} 

export const LogoutButton = connect((state: StateProps) => ({
  authenticator: state.authenticator,
  location: state.router.location,
  logout: state.logout,
}))(LogoutButtonComponent);